import styled from '@emotion/styled';
import { InfoCircleIcon } from '@zola/zola-ui/src/components/SvgIconsV3/InfoCircle';
import TooltipV2 from '@zola/zola-ui/src/components/TooltipV2';
import { COLORS3, FONT, SPACING, ZINDEX } from '@zola/zola-ui/src/styles/emotion';
import { Title3 } from '@zola/zola-ui/src/typography/Headings';

import { DrawerTitle } from 'components/common/zolaUI/Drawer';

export const EstimateContainer = styled.div`
  margin-top: ${SPACING.LG};
`;

export const StyledTitle3 = styled(Title3)`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const EstimateTitle = styled.span`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)};
`;

export const StyledDrawerTitle = styled(DrawerTitle)`
  margin-bottom: ${SPACING.XS};
`;

export const Top = styled.div`
  gap: ${SPACING.S24};
  display: flex;
  flex-direction: column;
  margin-bottom: ${SPACING.S24};
`;

export const TotalBudget = styled.div`
  display: flex;
  align-items: center;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 50%;
  ${FONT.textSizeUltraCompact(FONT.SIZE.REGULAR)}
  gap: ${SPACING.XS};
  position: relative;
`;

export const FakeInput = styled.div`
  text-align: right;
  padding: ${SPACING.S10} ${SPACING.SM};
  flex: 1 1 50%;
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const Allocation = styled.div<{ isEstimateMore: boolean }>`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${SPACING.XXS};
  border-radius: ${SPACING.XS};
  background-color: ${({ isEstimateMore }) =>
    isEstimateMore ? COLORS3.BLUSH_100 : COLORS3.MINT_100};
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
`;

export const StyledInfoCircleIcon = styled(InfoCircleIcon)`
  color: ${COLORS3.BLACK_050};
`;

export const StyledTooltipV2 = styled(TooltipV2)`
  position: absolute;
  z-index: ${ZINDEX.middle};
  bottom: ${SPACING.S32};
  right: 6px;
  width: 172px;
`;
